import {Btn} from "../../../../../AbstractElements";
import React, {useContext, useState} from "react";
import {Card, CardBody, Form, FormGroup} from "reactstrap";
import SweetAlert from "sweetalert2";
import axiosConfig from "../../../../../Config/axios";
import {getApplicationRoute} from "../../../../../Route/RouteIndex";
import Loader from "../../../../../Layout/Loader";
import AuthorizationContext from "../../../../../_helper/Authorization";
import type {AuthorizationContextType} from "../../../../../_helper/Authorization/AuthorizationTypes";
import TextInput from "../../../../../CommonElements/Input/TextInput";
import MultimediaField from "../../../../SystemCore/Multimedia/Component/MultimediaField";
import {useForm} from "react-hook-form";

interface walletCustomAmountFormProps {
    maxAmount: number
    maximumValidation?: boolean
    impactorID: number
    callBack?: () => void
    transactionType?: string
    action?: string
    attachmentRequired?: boolean
}

const WalletCustomAmountForm = ({
                                    maxAmount,
                                    action = 'Transfer',
                                    maximumValidation = true,
                                    impactorID,
                                    callBack,
                                    transactionType = 'transaction-type-point-purchase-collector-participant',
                                    attachmentRequired = false,
                                }: walletCustomAmountFormProps) => {
    const [loaderVisibility, setLoaderVisibility] = useState(false);
    const authContext = useContext(AuthorizationContext) as AuthorizationContextType;
    const {errorHandler} = authContext || {};
    const {
        register,
        handleSubmit,
        formState: {errors},
        setValue,
        watch,
    } = useForm();

    const amountValue = watch('amount');

    // Auto-cap amount to maxAmount when user types more
    React.useEffect(() => {
        if (maximumValidation && amountValue !== undefined && amountValue !== null && amountValue !== '' && Number(amountValue) > maxAmount) {
            setValue('amount', maxAmount);
        }
    }, [amountValue, maxAmount, maximumValidation, setValue]);

    const formattedMaxAmount = maxAmount.toLocaleString('en-LK', {
        style: 'currency',
        currency: 'LKR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    const amountLabel = maximumValidation ? `Amount (Max: ${formattedMaxAmount})` : 'Amount';

    const validationOptions = {
        required: 'Amount is required',
        ...(maximumValidation ? {
            max: {
                value: maxAmount,
                message: `Amount cannot exceed ${formattedMaxAmount}`
            }
        } : {}),
        min: {
            value: 0.01,
            message: 'Amount must be greater than 0'
        }
    };

    const openConfirmAlert = (data: any) => {
        SweetAlert.fire({
            title: `Do you want to ${action.toLowerCase()} ${data.amount}?`,
            text: `Once you ${action.toLowerCase()}, You cannot undo!`,
            icon: 'warning',
            showCancelButton: true,
            reverseButtons: true,
            confirmButtonText: 'Transfer',
            cancelButtonText: 'cancel',
        })
            .then((result) => {
                if (result.isConfirmed) {
                    processTransaction(data)
                }
            })
    }

    const processTransaction = (data: any) => {
        setLoaderVisibility(true);
        const params = {
            amount: data.amount,
            impactor_id: impactorID,
            transaction_type: transactionType,
            multimedia_id: data?.multimedia_id || null,
        };
        axiosConfig
            .post(`${getApplicationRoute('double-entry-wallet-transaction')}`, params)
            .then((response: { data: { data: any; }; }) => {
                if (response?.data?.data) {
                    callBack && callBack();
                }
                setLoaderVisibility(false);
            })
            .catch((exception: any) => {
                errorHandler(exception);
                setLoaderVisibility(false);
            });
    }
    return <Card>
        <Loader visibility={loaderVisibility}/>
        <CardBody>
            <Form onSubmit={handleSubmit(openConfirmAlert)}>
                <TextInput name={'amount'} type={'number'} label={amountLabel} register={register}
                           errors={errors} placeholder={'0.00'} options={validationOptions}/>
                {attachmentRequired && (
                    <MultimediaField
                        label={'Attachment'}
                        name={'multimedia_id'}
                        register={register}
                        setValue={setValue}
                        errors={errors}
                        options={{required: 'Attachment is required'}}
                    />
                )}
                <FormGroup className="mb-0">
                    <Btn attrBtn={{
                        className: 'd-block w-100',
                        color: 'primary',
                        type: 'submit'
                    }}>{action}</Btn>
                </FormGroup>
            </Form>
        </CardBody>
    </Card>
}

export default WalletCustomAmountForm;